import { render, staticRenderFns } from "./DocumentDataTable.vue?vue&type=template&id=874183a0&scoped=true&"
import script from "./DocumentDataTable.vue?vue&type=script&lang=js&"
export * from "./DocumentDataTable.vue?vue&type=script&lang=js&"
import style0 from "./DocumentDataTable.vue?vue&type=style&index=0&id=874183a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874183a0",
  null
  
)

export default component.exports